import React from "react";
import ParticlesBackground from "./ParticlesBackground";
import "./Jibubot.css";
import Jibubot from "./images/JibuBotLogo.png";

const WhoIsJibuBot = ({ isDarkMode }) => {
  return (
    <section
      className={`jibu-hero reduced-height ${
        isDarkMode ? "dark-mode" : "light-mode"
      }`}
    >
      {/* 🌐 SHARED PARTICLES BACKGROUND */}
      <ParticlesBackground isDarkMode={isDarkMode} />

      <div className="hero-grid">
        <div className="text-content">
          <h1>Who is JibuBot?</h1>
          <p>
            JibuBot is your intelligent assistant designed to automate
            conversations, provide smart replies, and support your users around
            the clock. Whether it's sales, support, or engagement, JibuBot helps
            you do it faster and smarter.
          </p>
        </div>

        <div className="image-container">
          <div className="phone-wrapper">
            <div className="notch"></div>
            <div className="phone-screen">
              <div className="phone-header">
                <img src={Jibubot} alt="JibuBot Logo" />
                <span>JibuBot · AstraSight</span>
              </div>

              <div className="chat-screen">
                <div className="chat incoming">
                  <div className="bubble">
                    Hello, I’m looking for someone to build a website for my
                    agro-processing startup.
                  </div>
                </div>

                <div className="chat outgoing">
                  <div className="bubble">
                    👋 Hi! I’m <strong>JibuBot</strong> from{" "}
                    <strong>AstraSight Technologies</strong>.
                    <br />
                    <br />
                    💡 We specialize in:
                    <br />– Website Development
                    <br />– Graphic Design
                    <br />– Cybersecurity
                    <br />– Social Media Marketing
                    <br />
                    <br />
                    Would you like a quote or to speak to a human agent?
                  </div>
                </div>

                <div className="chat incoming">
                  <div className="bubble">
                    I'd like to see some past projects first.
                  </div>
                </div>

                <div className="chat outgoing">
                  <div className="bubble">
                    🔗 Here’s a few of our recent works:
                    <br />– pesco.africa
                    <br />– mountelgonmillers.com
                    <br />– kijenge.co.tz
                    <br />
                    <br />
                    Would you like me to send a portfolio PDF?
                  </div>
                </div>

                <div className="chat outgoing typing">
                  <div className="bubble typing-bubble">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIsJibuBot;
